import React, { useRef, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useScreen } from '../../styles'
import { makeStyles } from '@material-ui/core';
import { isIOS } from '../../utils';
import { get, last } from '../../lib/lodash';
import clsx from 'clsx';

const theStyles = makeStyles((theme) => ({
  tradeMarker: {
    position: 'absolute',
    top: p => p.topOffset,
    left: 0,
  }
}))

export const AutoComplete = React.forwardRef((props, ref) => {
  const controlRef = useRef();
  const { isMobileXS } = useScreen();
  const [isIos] = useState(isIOS());
  const topOffset = get(props, 'topOffset', -50) - (isIos ? 20 : 0);
  const styles = theStyles({ topOffset });

  const setElementStyle = (query, stl = []) => {
    try {
      const elem = last(document.querySelectorAll(query));
      stl.map(s => {
        elem.style[s.key] = s.value;
      })
    } catch (err) {
      console.error(err);
    }
  }

  const onOpen = () => {
    try {
      props.onOpen && props.onOpen();
  
      if (isMobileXS) {
        setElementStyle('.formScrollContainer', [{ key: 'overflow', value: 'visible' }]);
        
        setTimeout(() => {
          try {
            controlRef.current.scrollIntoView({
              "behaviour": "smooth",
              "block": "start",
            });
          } catch (err) {
            console.error(err);
          }
        }, 700);
      }
    } catch (err) {

    }
  }

  const onClose = () => {
    props.onClose && props.onClose();

    if (isMobileXS) {
      setElementStyle('.formScrollContainer', [{ key: 'overflow', value: 'auto' }]);
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <div ref={controlRef} className={clsx(styles.tradeMarker, 'tradeMarker')} />
      <Autocomplete {...props} disablePortal={!!isMobileXS} ref={ref} onOpen={onOpen} onClose={onClose} />
    </div>
  )
})